import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import Panel from "../UI/Panel/Panel";
import PanelContent from "../UI/Panel/PanelContent";
import PanelTitle from "../UI/Panel/PanelTitle";
import { Button } from "../../Theme/Hyper";
const Main = styled.div`
  padding-top: 52px;
  margin-bottom: 52px;
`;

export default function () {
  return (
    <Main>
      <RenderList />
    </Main>
  );
}

const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
  > tbody > tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.05);
  }

  th {
    padding: 10px;
    border-top: 1px solid #dee2e6;
  }
  td {
    padding-left: 10px;
    padding-right: 10px;
    border-top: 1px solid #dee2e6;
    width: ${(props) => props.width};
    padding: 8px;
    padding-left: 10px;
    padding-right: 10px;
    border-top: 1px solid #dee2e6;
    white-space: nowrap;
    overflow: hidden;
    font-size: 0.8em;
  }
  > tbody > tr:hover {
    background-color: #14ec8e;
    color: white;
    cursor: pointer;
  }
`;

const TH = styled.th`
  border-top: 0;
  border-bottom: 0;
  font-weight: 800;
  font-size: 0.8em;
  text-transform: uppercase;
  color: #343a40;
  text-align: left;
`;
function RenderList() {
  useEffect(() => {
    getData();
  }, []);

  function getData() {}
  return (
    <>
      <Button
        style={{ width: "200px", margin: "1em" }}
        green
        onClick={() => {}}
      >
        Create New Queue
      </Button>
      <Panel style={{ marginTop: "1em" }}>
        <PanelTitle title={"Render Queues"} />
        <PanelContent>
          <Table>
            <thead>
              <tr>
                <TH>ID</TH>
                <TH>Name</TH>
                <TH>Rows</TH>
              </tr>
            </thead>
            <tbody>
              {[].map((formation) => {
                return (
                  <tr
                    onClick={() => {
                      // setSelectedFormation(
                      //   JSON.parse(JSON.stringify(formation))
                      // );
                    }}
                  >
                    <td>{formation._id}</td>
                    <td>{formation.name}</td>
                    <td>{formation.rows}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </PanelContent>
      </Panel>
    </>
  );
}
